import React, { useEffect } from 'react';
import * as yup from 'yup';
import { Formik, Form } from 'formik';
import { Button, Error, CheckboxInput } from '@figure/frontlib-gui';
import { FormErrorHandler } from 'shared/components/StatusMessages';
import { useAch, usePersonalLoan, usePersonalLoanRouteFsm, useTelemetry } from 'shared/hooks';
import { PageHeader } from 'shared/components/Typography';

const Autopay = () => {
  const { getAchLogins, logins: achLogins, loading, error: achError } = useAch();
  const { personalLoan, saveAutopayAch, error: personalLoanError } = usePersonalLoan();
  const runRouter = usePersonalLoanRouteFsm();
  const { telemetry } = useTelemetry();

  const serverError = achError || personalLoanError || '';

  useEffect(() => {
    getAchLogins();
  }, [getAchLogins]);

  const handleSubmit = async (data) => {
    await saveAutopayAch(data);
    telemetry('plAutopay');

    runRouter();
  };

  if (loading) return null;

  let achLogin;
  let achLoginAccount;
  achLogins.forEach((al) =>
    al.accounts.forEach((a) => {
      if (a.plaidAccountId === personalLoan.disburseAccount.achAccountId) {
        achLogin = al;
        achLoginAccount = a;
      }
    })
  );

  return (
    <>
      <PageHeader>Confirm your account for monthly payments.</PageHeader>
      <Formik
        enableReinitialize
        initialValues={{
          uuid: personalLoan.disburseAccount?.uuid || '',
          plUuid: personalLoan.uuid || '',
          consent: '',
        }}
        validationSchema={yup.lazy(() =>
          yup.object().shape({
            plUuid: yup.string().required(),
            consent: yup.string().test('has-consent', 'Required', (value) => value === 'YES'),
          })
        )}
        onSubmit={handleSubmit}
      >
        {({ values, errors, touched, handleSubmit, setFieldValue }) => (
          <>
            <FormErrorHandler errors={errors} touched={touched} serverError={serverError} />
            <Form onSubmit={handleSubmit}>
              <p>
                {achLogin && achLogin.institutionName
                  ? achLogin.institutionName
                  : 'Financial institution'}
                <br />
                {personalLoan.disburseAccount?.accountType === 'CHECKING'
                  ? 'Checking'
                  : 'Savings'}{' '}
                {achLogin?.institutionName?.toUpperCase() === 'CHASE' &&
                achLoginAccount?.officialName ? (
                  <>
                    {achLoginAccount.officialName} - {achLoginAccount.mask}
                  </>
                ) : (
                  <>
                    {personalLoan.disburseAccount?.routingNumber} -{' '}
                    {personalLoan.disburseAccount?.accountNumber}
                  </>
                )}
              </p>

              <CheckboxInput
                id="consent"
                label="I confirm the account selected above will be used for monthly payments."
                name="consent"
                checked={values.consent === 'YES'}
                value="YES"
                errorText={touched.consent && errors.consent}
                onChange={(e) => setFieldValue('consent', e.target.checked ? 'YES' : '')}
              />

              <Error display="block">{serverError}</Error>

              <Button
                onClick={handleSubmit}
                primary
                large
                center
                data-test-id="save-and-continue"
                type="button"
              >
                Save and continue
              </Button>
            </Form>
          </>
        )}
      </Formik>
    </>
  );
};

export default Autopay;
